import { Component } from "@angular/core";

@Component({
  selector: "krd-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
  standalone: true,
})
export class LoadingComponent {}
